import axios            from 'axios'
import { centralStore } from '../store/store'
import router           from '../router'

const authBaseState = {
  loggedIn: false,
  csrfToken: '',
  userType: null,
  userId: null,
  isActive: false,
  passwordChanged: false,
  profileImage: ''
}

export const authMixin = {
  data () {
    return {
      authRegex: [[/loggedIn=([\w]+)/, 'loggedIn'],
        [/csrftoken=([^\s]+)/, 'csrfToken'],
        [/userType=([^\s]+)/, 'userType'],
        [/userId=([\d]+)/, 'userId'],
        [/isActive=([^\s]+)/, 'isActive'],
        [/passwordChanged=([^\s]+)/, 'passwordChanged']
      ],
      showContent: true
    }
  },
  methods: {
    logOut () {
      axios.get(this.apiPrefix + this.authApiUrl + '/logout', {
        headers: {
          'X-CSRFTOKEN': centralStore.getters.getAuth['csrfToken']
        }
      })
        .then(() => {
          centralStore.commit('setAuth', {...authBaseState})

          router.push({name: 'Main'})
        })
        .catch(() => {
        })
    },
    logIn (email, password, rememberMe) {
      return new Promise((resolve, reject) => {
        axios.post(this.apiPrefix + this.authApiUrl + '/login/', {
          email: email,
          password: password,
          remember_me: rememberMe
        }).then((resp) => {
          let authValues = this.setAuthValues(...this.authRegex)
          centralStore.commit('setAuth', authValues)
          this.changeLocale(resp.data.user.preferred_language)

          if (authValues['loggedIn']) {
            resolve()
          } else {
            reject()
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    checkIfLogged () {
      centralStore.commit('setLoggedIn', false);
      this.showContent = false;

      return axios.get(this.apiPrefix + this.authApiUrl + '/is-authenticated/')
        .then(resp => {
          if (resp.status === 200) {
            const authValues = this.setAuthValues(...this.authRegex)

            centralStore.commit('setAuth', authValues)
            this.showContent = true;

            if (authValues['loggedIn']) {
              return true
            }
          }
        })
        .catch(err => {
          if(err.response.status === 401){
            centralStore.commit('setAuth', authBaseState);
            this.showContent = true;
            return false;
          }
        })

    },
    setAuthValues (...regExpressions) {
      let cookie = document.cookie
      let values = {...authBaseState}

      for (let expr of regExpressions) {
        if (expr[1] === 'isActive' || expr[1] === 'loggedIn' || expr[1] === 'passwordChanged') {
          values[expr[1]] = this.parseCookie(cookie, expr[0]) === 'True'
        } else {
          values[expr[1]] = this.parseCookie(cookie, expr[0])
        }

      }

      return values
    },
    parseCookie (cookie, regex) {
      let found = cookie.match(regex)

      if (found) {
        return found[1].replace(';', '')
      }
      return false
    },
    validateFieldLength (minLen, maxLen, data) {
      return minLen <= data.length && data.length <= maxLen
    },
    validateFieldsMatch (field1, field2) {
      return field1 === field2
    }
  },
  computed: {
    computedLoggedIn () {
      return centralStore.getters.getAuth['loggedIn']
    },
    computedShowMainContent () {
      return this.showContent;
    }
  }
}